(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hair-chews-editorial"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hair-chews-editorial'))customElements.define('hair-chews-editorial',class extends HTMLElement{connectedCallback(){this.querySelectorAll('[data-hc-pdp]').forEach(link=>{const url=new URL(link.href,location.origin);const params=new URLSearchParams(location.search);for(const [key,value] of params){if(key.startsWith('utm_')||['gclid','fbclid','ttclid','preview_theme_id','pb'].includes(key))url.searchParams.set(key,value);}link.href=url.pathname+url.search+url.hash;});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hair-chews-story"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('hair-chews-story')) {
  customElements.define('hair-chews-story', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelectorAll('.hgs-review__photo').forEach(image => {
        const hide = () => {image.hidden = true;};
        image.addEventListener('error',hide,{signal});
        if(image.complete && !image.naturalWidth)hide();
      });
      const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      this.querySelectorAll('[data-hgs-buy]').forEach(link => link.addEventListener('click', event => {
        let target = document.getElementById('hgs-purchase');
        if (!target) { try { target = document.querySelector(this.dataset.buySelector); } catch {} }
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({behavior:motion(),block:'center'});
        target.focus({preventScroll:true});
      }, {signal}));
      const track = this.querySelector('.hgs-reviews__track');
      const cards = Array.from(this.querySelectorAll('[data-hgs-review]'));
      const dots = this.querySelector('.hgs-reviews__dots');
      const prev = this.querySelector('.hgs-reviews__nav--prev');
      const next = this.querySelector('.hgs-reviews__nav--next');
      const position = this.querySelector('.hgs-reviews__position');
      if (!track || !cards.length) return;
      let points = [];
      const index = () => points.reduce((best, n, i) => Math.abs(n-track.scrollLeft) < Math.abs(points[best]-track.scrollLeft) ? i : best, 0);
      const go = i => track.scrollTo({left:points[Math.max(0,Math.min(points.length-1,i))],behavior:motion()});
      const update = () => {
        const current = index();
        Array.from(dots.children).forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
        prev.disabled = current === 0; next.disabled = current === points.length-1;
        position.textContent = (current+1)+' / '+points.length;
      };
      const layout = () => {
        const max = Math.max(0,track.scrollWidth-track.clientWidth);
        const first = cards[0].getBoundingClientRect().left;
        points = [...new Set(cards.map(card => Math.round(Math.min(max,card.getBoundingClientRect().left-first))))];
        dots.replaceChildren();
        points.forEach((point,i) => {
          const dot = document.createElement('button');dot.type='button';
          dot.setAttribute('aria-label',track.getAttribute('aria-label')+' '+(i+1));
          dot.addEventListener('click',() => go(i));dots.appendChild(dot);
        });update();
      };
      prev.addEventListener('click',() => go(index()-1),{signal});
      next.addEventListener('click',() => go(index()+1),{signal});
      track.addEventListener('scroll',update,{signal,passive:true});
      track.addEventListener('keydown',event => {
        if(event.target!==track)return;
        if(event.key==='ArrowRight'){event.preventDefault();go(index()+1);}
        if(event.key==='ArrowLeft'){event.preventDefault();go(index()-1);}
        if(event.key==='Home'){event.preventDefault();go(0);}
        if(event.key==='End'){event.preventDefault();go(points.length-1);}
      },{signal});
      this.observer = new ResizeObserver(layout);this.observer.observe(track);layout();
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rippel-panel-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rippel-panel-story')) {
  customElements.define('rippel-panel-story', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const form = this.querySelector('[data-rp-calculator]');
      if (!form) return;
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const width = Number(form.elements.wall_width.value);
        const height = Number(form.elements.wall_height.value);
        if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return;
        const area = width * height / 10000;
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {maximumFractionDigits: 2});
        form.querySelector('[data-rp-area]').textContent = formatter.format(area);
        form.querySelector('[data-rp-count]').textContent = String(Math.ceil(Number((area / 2.97).toFixed(10))));
        form.querySelector('[data-rp-result]').hidden = false;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sovaia-advertorial-v5"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-sv5]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const params = new URLSearchParams(location.search);
      root.querySelectorAll('[data-sv5-cta]').forEach((link) => {
        const target = new URL(link.href, location.origin);
        for (const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid','ttclid','preview_theme_id']) {
          if (params.has(key)) target.searchParams.set(key, params.get(key));
        }
        link.href = target.pathname + target.search;
      });
      const bar = root.querySelector('.sv5__sticky');
      const hero = root.querySelector('.sv5__hero');
      if (bar && hero && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          bar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        });
        observer.observe(hero);
        root.addEventListener('sv5:cleanup', () => observer.disconnect(), { once: true });
      }
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-sv5]').forEach((root) => root.dispatchEvent(new Event('sv5:cleanup')));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sovaia-cyperus-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-cy1]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const params = new URLSearchParams(location.search);
      if (root.dataset.mode === 'editorial') {
        root.querySelectorAll('[data-cy1-cta]').forEach(link => {
          const url = new URL(link.href, location.origin);
          ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid','ttclid','preview_theme_id'].forEach(key => {
            if (params.has(key)) url.searchParams.set(key, params.get(key));
          });
          link.href = url.pathname + url.search;
        });
      }
      const bar = root.querySelector('.cy1__sticky');
      const hero = root.querySelector('.cy1__hero');
      if (bar && hero && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => { bar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0; });
        observer.observe(hero);
        root.addEventListener('cy1:cleanup', () => observer.disconnect(), {once:true});
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-cy1]').forEach(root => root.dispatchEvent(new Event('cy1:cleanup'))));
})();

  } catch(e) { console.error(e); }
})();
})();
